import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SISENDMESSAGE;

export default {
  post(payload) {
    return baseApi.post(resource, payload);
  },
};
